import React from 'react'

const Icon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
		<path
			className="fill-current"
			fillRule="evenodd"
			d="M20 8c0 2.533-1.2 4.933-3.2 6.4 3.867 1.733 6.667 5.333 7.2 9.6h-2.667c-.666-4.533-4.666-8-9.333-8s-8.667 3.467-9.333 8H0c.533-4.267 3.333-7.867 7.2-9.6C5.2 12.933 4 10.533 4 8c0-4.4 3.6-8 8-8s8 3.6 8 8zM6.666 8c0 2.934 2.4 5.334 5.334 5.334 2.933 0 5.333-2.4 5.333-5.333 0-2.933-2.4-5.333-5.333-5.333-2.934 0-5.333 2.4-5.333 5.333z"
			clipRule="evenodd"
		/>
	</svg>
)

export default Icon
